/**
 * @flow
 * @relayHash f29a215e6f22331aa36d26969cc30360
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CashTransferRequestDetailsFormBase_viewer$ref = any;
export type CashTransferRequestDetailsFormBaseQueryVariables = {|
  cashTransferRequestId: string
|};
export type CashTransferRequestDetailsFormBaseQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: CashTransferRequestDetailsFormBase_viewer$ref
  |}
|};
export type CashTransferRequestDetailsFormBaseQuery = {|
  variables: CashTransferRequestDetailsFormBaseQueryVariables,
  response: CashTransferRequestDetailsFormBaseQueryResponse,
|};
*/


/*
query CashTransferRequestDetailsFormBaseQuery(
  $cashTransferRequestId: ID!
) {
  viewer {
    ...CashTransferRequestDetailsFormBase_viewer_3d5cEW
    id
  }
}

fragment CashTransferRequestDetailsFormBase_viewer_3d5cEW on Query {
  cashTransferRequests(id: $cashTransferRequestId) {
    edges {
      node {
        id
        createdAt
        updatedAt
        subtype
        amount
        custodian
        currency
        blocked
        status
        contraParty
        batch {
          createdAt
          id
          name
          inverseBatch {
            id
            name
          }
        }
        cashtransferrequestapprovalSet {
          edges {
            node {
              approvedAt
              approvedBy {
                fullName
                id
              }
              id
            }
          }
        }
        cashTransfer {
          id
          brokerActivity {
            id
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "cashTransferRequestId",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdAt",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CashTransferRequestDetailsFormBaseQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "CashTransferRequestDetailsFormBase_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "cashTransferRequestId",
                "variableName": "cashTransferRequestId"
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "CashTransferRequestDetailsFormBaseQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "cashTransferRequests",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "cashTransferRequestId"
              }
            ],
            "concreteType": "CashTransferRequestNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CashTransferRequestNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CashTransferRequestNode",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "updatedAt",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "subtype",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "amount",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "custodian",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "currency",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "blocked",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "status",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "contraParty",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "batch",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CashTransferRequestBatchNode",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v1/*: any*/),
                          (v3/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "inverseBatch",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CashTransferRequestBatchNode",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              (v3/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "cashtransferrequestapprovalSet",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CashTransferRequestApprovalNodeConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CashTransferRequestApprovalNodeEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "CashTransferRequestApprovalNode",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "approvedAt",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "approvedBy",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "UserNode",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "fullName",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      (v1/*: any*/)
                                    ]
                                  },
                                  (v1/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "cashTransfer",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CashTransferNode",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "brokerActivity",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BrokerActivityNode",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v1/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "CashTransferRequestDetailsFormBaseQuery",
    "id": null,
    "text": "query CashTransferRequestDetailsFormBaseQuery(\n  $cashTransferRequestId: ID!\n) {\n  viewer {\n    ...CashTransferRequestDetailsFormBase_viewer_3d5cEW\n    id\n  }\n}\n\nfragment CashTransferRequestDetailsFormBase_viewer_3d5cEW on Query {\n  cashTransferRequests(id: $cashTransferRequestId) {\n    edges {\n      node {\n        id\n        createdAt\n        updatedAt\n        subtype\n        amount\n        custodian\n        currency\n        blocked\n        status\n        contraParty\n        batch {\n          createdAt\n          id\n          name\n          inverseBatch {\n            id\n            name\n          }\n        }\n        cashtransferrequestapprovalSet {\n          edges {\n            node {\n              approvedAt\n              approvedBy {\n                fullName\n                id\n              }\n              id\n            }\n          }\n        }\n        cashTransfer {\n          id\n          brokerActivity {\n            id\n          }\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ad6cf2a2e7d3ec83e7c9a6426093f134';
module.exports = node;
